import React from 'react';
import noop from 'lodash/noop';

export interface PopperDropdownContextProps {
  setToggleRef: (node: HTMLElement | null) => void;
  toggleElement: HTMLElement | null;
}

export const PopperDropdownContext = React.createContext<PopperDropdownContextProps>({
  setToggleRef: noop,
  toggleElement: null,
});
PopperDropdownContext.displayName = 'PopperDropdownContext';
